import type { LocalizedText } from "../../app/i18n/i18n";
import {
MemberPromotionDurationUnit,
MemberPromotionGrantStatus,
MemberPromotionLaterCancellationBehavior,
MemberPromotionQualificationCondition,
MemberPromotionQualificationTiming,
MemberPromotionRedemptionStartMode,
MemberPromotionRewardKind,
MemberPromotionTemplateRewardMode
} from "./memberPromotionApi";

export function rewardModeLabel(value: MemberPromotionTemplateRewardMode): LocalizedText {
  switch (value) {
    case MemberPromotionTemplateRewardMode.PriceAdjustment: return "Price adjustment only";
    case MemberPromotionTemplateRewardMode.WalletCredit: return "Value account only";
    case MemberPromotionTemplateRewardMode.Choice: return "Selectable when entering";
  }
}

export function rewardKindLabel(value: MemberPromotionRewardKind): LocalizedText {
  return value === MemberPromotionRewardKind.WalletCredit ? "Value account" : "Price adjustment";
}

export function durationUnitLabel(value: MemberPromotionDurationUnit): LocalizedText {
  switch (value) {
    case MemberPromotionDurationUnit.Days: return "Days";
    case MemberPromotionDurationUnit.Weeks: return "Weeks";
    case MemberPromotionDurationUnit.Months: return "Months";
    case MemberPromotionDurationUnit.ContributionCycles: return "Contribution cycles";
  }
}

export function startModeLabel(value: MemberPromotionRedemptionStartMode): LocalizedText {
  switch (value) {
    case MemberPromotionRedemptionStartMode.NextDueDate: return "Next due date";
    case MemberPromotionRedemptionStartMode.FixedDate: return "Fixed start date";
    case MemberPromotionRedemptionStartMode.BeforeContractRenewal: return "Before contract renewal";
    case MemberPromotionRedemptionStartMode.AfterContractEnd: return "Append after contract end";
  }
}

export function qualificationTimingLabel(value: MemberPromotionQualificationTiming): LocalizedText {
  switch (value) {
    case MemberPromotionQualificationTiming.Immediate: return "Immediately";
    case MemberPromotionQualificationTiming.FixedDate: return "Fixed date";
    case MemberPromotionQualificationTiming.AfterReferredContractStart: return "After referred contract start";
  }
}

export function qualificationConditionLabel(value: MemberPromotionQualificationCondition): LocalizedText {
  switch (value) {
    case MemberPromotionQualificationCondition.ActiveOnDate: return "Active on due date";
    case MemberPromotionQualificationCondition.NoCancellationRecorded: return "No cancellation recorded";
    case MemberPromotionQualificationCondition.NoCancellationEffective: return "No effective cancellation";
    case MemberPromotionQualificationCondition.ManualReview: return "Manual review";
  }
}

export function laterCancellationBehaviorLabel(value: MemberPromotionLaterCancellationBehavior): LocalizedText {
  switch (value) {
    case MemberPromotionLaterCancellationBehavior.IgnoreAfterQualification: return "Ignore after qualification";
    case MemberPromotionLaterCancellationBehavior.BlockUntilRedemption: return "Block until redemption";
    case MemberPromotionLaterCancellationBehavior.RevokeUntilBenefitEnd: return "Revocable until benefit end";
    case MemberPromotionLaterCancellationBehavior.ManualReview: return "Manual review";
  }
}

export function grantStatusLabel(value: MemberPromotionGrantStatus): LocalizedText {
  switch (value) {
    case MemberPromotionGrantStatus.Pending: return "pending";
    case MemberPromotionGrantStatus.Qualified: return "qualified";
    case MemberPromotionGrantStatus.Redeemed: return "redeemed";
    case MemberPromotionGrantStatus.Rejected: return "rejected";
    case MemberPromotionGrantStatus.Cancelled: return "cancelled";
    case MemberPromotionGrantStatus.NeedsReview: return "review needed";
  }
}
